import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { SignOut, Shield } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

export default function DashboardLayout({ children, title, actions }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "var(--bg)" }}>
      {/* top nav */}
      <header className="sticky top-0 z-30 border-b border-[var(--border-soft)] bg-[var(--bg)]/85 backdrop-blur-md">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="nav-home-link">
            <div className="h-9 w-9 rounded-xl flex items-center justify-center font-black text-white"
                 style={{ background: "var(--primary)", border: "1.5px solid var(--ink)", boxShadow: "2px 2px 0 0 var(--ink)" }}>
              RA
            </div>
            <span className="display font-black text-xl tracking-tight">Rating Ally</span>
          </Link>
          <div className="flex items-center gap-3">
            {user?.is_admin && (
              <Link
                to="/admin"
                className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-orange-50 text-orange-600 border border-orange-200 hover:bg-orange-100 transition-colors"
              >
                <Shield size={14} weight="fill" />
                Admin
              </Link>
            )}
            <span className="hidden sm:inline text-sm text-[var(--ink-muted)]" data-testid="nav-user-name">
              {user?.business_name || user?.name}
            </span>
            <button
              data-testid="nav-logout-btn"
              onClick={async () => { await logout(); navigate("/"); }}
              className="btn-ghost"
              style={{ padding: "8px 14px", fontSize: 13 }}
            >
              <SignOut size={16} weight="bold" /> Logout
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-5 sm:px-8 py-8 sm:py-10">
        {(title || actions) && (
          <div className="flex items-center justify-between gap-4 mb-8 flex-wrap">
            {title && <h1 className="display text-3xl sm:text-4xl font-black tracking-tighter">{title}</h1>}
            {actions && <div className="flex items-center gap-3">{actions}</div>}
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
